module.exports = __webpack_public_path__ + "img/Alumni.c70635a0.jpg";